import { isEmpty } from 'lodash';
import { sectionNameListMapping } from '../constants';

export const feedbackCount = (label, feedbackType, empty) =>
  !isEmpty(feedbackType)
    ? `${!empty ? ' | ' : ''}${label} ${feedbackType.length}`
    : '';

export const getFeedbacksCountString = (t, feedbacks) => {
  let feedbacksCountString = '';
  feedbacksCountString += feedbackCount(
    feedbacks?.source?.length === 1 ? t('Check') : t('Checks'),
    !isEmpty(feedbacks[sectionNameListMapping.sources])
      ? feedbacks[sectionNameListMapping.sources]
      : feedbacks.source,
    isEmpty(feedbacksCountString),
  );

  feedbacksCountString += feedbackCount(
    feedbacks?.workstatus?.length === 1 ? t('Work_order') : t('Work_orders'),
    !isEmpty(feedbacks[sectionNameListMapping.workstatus])
      ? feedbacks[sectionNameListMapping.workstatus]
      : feedbacks.workstatus,
    isEmpty(feedbacksCountString),
  );

  return feedbacksCountString;
};

export const isFeedbackEmpty = feedback =>
  isEmpty(feedback[sectionNameListMapping.workstatus]) &&
  isEmpty(feedback[sectionNameListMapping.sources]);

export const feedbackObj = {
  source: [],
  workstatus: [],
  recommendations: [],
  comments: [],
  parts: [],
  recomm: [],
};

export const getFeedbackObj = (feedbacks, fdback, recom = []) => {
  feedbacks?.reduce((acc, feed) => {
    const source = feed.feedback[sectionNameListMapping.sources] || [];
    const workStatus = feed.feedback[sectionNameListMapping.workstatus] || [];
    const recommendations =
      feed.feedback[sectionNameListMapping.recommendations] || [];
    const comments = feed.feedback[sectionNameListMapping.comments] || [];
    const parts = feed.feedback[sectionNameListMapping.parts] || [];
    acc.source = [...acc.source, ...source];
    acc.workstatus = [...acc.workstatus, ...workStatus];
    acc.recommendations = [...acc.recommendations, ...recommendations];
    acc.comments = [...acc.comments, ...comments];
    acc.parts = [...acc.parts, ...parts];
    return acc;
  }, fdback);
  if (!isEmpty(recom))
    recom?.reduce((acc, rec) => {
      const recomm = rec || {};
      acc.recomm = [...acc.recomm, recomm];
      return acc;
    }, fdback);
  return fdback;
};

export const getFeedbackObj2 = (feedbacks, fdback, recom = []) => {
  feedbacks?.reduce((acc, feed) => {
    const source1 = {
      date: feed.date,
      recommendations: feed.feedback[sectionNameListMapping.recommendations],
    };
    const source = feed.feedback[sectionNameListMapping.sources] || [];
    const workStatus = feed.feedback[sectionNameListMapping.workstatus] || [];
    const recommendations = source1 || [];
    const comments = feed.feedback[sectionNameListMapping.comments] || [];
    const parts = feed.feedback[sectionNameListMapping.parts] || [];
    acc.source = [...acc.source, ...source];
    acc.workstatus = [...acc.workstatus, ...workStatus];
    acc.recommendations = [...acc.recommendations, ...recommendations];
    acc.comments = [...acc.comments, ...comments];
    acc.parts = [...acc.parts, ...parts];
    return acc;
  }, fdback);
  if (!isEmpty(recom))
    recom?.reduce((acc, rec) => {
      const recomm = rec || {};
      acc.recomm = [...acc.recomm, recomm];
      return acc;
    }, fdback);
  return fdback;
};
